import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InfraEntities } from "../InfraEntities";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";

interface ContainerViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class ContainerViewPage extends Component<ContainerViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.container(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}